import type { SVGProps } from "react";

export function IconBlueGlobe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 59C46.9117 59 59 46.9117 59 32C59 29.5631 58.6772 27.2017 58.072 24.9561L54.2502 28.5L47.5002 20.85H32.3003V16.8H37.7003L45.8528 8.81979C41.8028 6.39422 37.0642 5 32 5C28.8339 5 25.7952 5.54493 22.9723 6.54614L15 21.15H10.45V30.95L5.05263 33.6996C5.2457 36.808 5.96473 39.774 7.1218 42.5096C7.05031 42.3406 6.98051 42.1707 6.91239 42H13L20 49V56.1934C20 56.1934 20 56.1934 20 56.1934C23.6149 57.9899 27.6895 59 32 59ZM34.6997 37.4H27.9497V27.25L32.3747 25.25H42.7997L48.1997 33.35L44.1497 40.775L40.0997 48.2H34.6997V42.8V37.4Z"
        fill="#5486FA"
      />
      <circle cx="32" cy="32" r="27" stroke="#23232C" strokeWidth="1.5" />
    </svg>
  );
}
